<template>
  <div>
    <van-nav-bar
      :title="type==='1'?'添加通知':'添加资讯'"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />

    <van-form @submit="onSubmit">
      <van-field
        clearable
        v-model="title"
        name="title"
        label="标题"
        placeholder="标题"
        :rules="[{ required: true, message: '请填写标题' }]"
      />

      <van-field name="type" label="类型">
        <template #input>
          <van-radio-group v-model="type" direction="horizontal">
            <van-radio name="1">通知</van-radio>
            <van-radio name="2">资讯</van-radio>
            <van-radio name="3">轮播图</van-radio>
          </van-radio-group>
        </template>
      </van-field>

      <van-field
        v-if="type==2||type==3"
        clearable
        v-model="src"
        name="src"
        label="公众号链接"
        placeholder="公众号链接"
        :rules="[{ required: true, message: '请填写公众号链接' }]"
      />

      <!--      <van-field-->
      <!--        v-if="type==1"-->
      <!--        v-model="des"-->
      <!--        rows="2"-->
      <!--        autosize-->
      <!--        name="des"-->
      <!--        clearable-->
      <!--        label="描述"-->
      <!--        type="textarea"-->
      <!--        maxlength="200"-->
      <!--        placeholder="描述"-->
      <!--        show-word-limit-->
      <!--        :rules="[{ required: true, message: '请填写描述' }]"-->
      <!--      />-->

      <van-field
        v-if="type!=3"
        v-model="content"
        rows="2"
        autosize
        name="content"
        clearable
        :label="type==='1'?'内容':'介绍'"
        type="textarea"
        :maxlength="type==='1'?1500:28"
        :placeholder="type==='1'?'内容':'介绍'"
        show-word-limit
        :rules="[{ required: true, message:type==='1'?'请填写通知内容':'请填写简介'  }]"
      />
      <van-row>
        <van-col span="9"></van-col>
        <van-col span="8">
          <!--          accept=".jpg,.jpeg,.png"-->
          <van-uploader v-model="fileList" :max-count="1" :before-read="before_read"
                        :after-read="after_read" :before-delete="delete_file" accept="*" multiple>
            <van-button round block icon="plus" type="primary">图片</van-button>
          </van-uploader>
        </van-col>
        <van-col span="7"></van-col>
      </van-row>
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">
          <div v-show="type==='1'">添加通知</div>
          <div v-show="type==='2'">添加资讯</div>
          <div v-show="type==='3'">添加轮播图</div>
        </van-button>
      </div>
    </van-form>


  </div>
</template>

<script>
import Vue from 'vue';
import {
  NavBar,
  Form,
  Field,
  Button,
  Dialog,
  Col,
  Row,
  Cell,
  Radio,
  RadioGroup,
  Uploader,
} from 'vant';

Vue.use(Form);
Vue.use(NavBar);
Vue.use(Field);
Vue.use(Button);
Vue.use(Dialog);
Vue.use(Col);
Vue.use(Row);
Vue.use(Cell);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Uploader);
import {AddNews} from "../../../network/news";
import {upLoadImageToQiNiu, getToken} from "@/network/upLoader";

export default {
  name: "AddNews",
  data() {
    return {
      title: "",
      type: '1',
      src: '',
      des: '',
      content: '',
      //image file
      fileList: [],
      imageSrc: ''
    }
  },
  methods: {
    onClickLeft() {
      this.$router.replace("NewsList");
    },
    Dialoginfo(title, message) {
      Dialog.alert({
        title,
        message
      }).then(() => {
        // on close
      });
    }
    ,
    onSubmit(values) {
      if (values.type === '1') {
        values['src'] = ' ';
        values['des'] = ' ';
        // values['img'] = ' ';
      } else if (values.type === '2') {
        values['des'] = ' ';
        if (this.imageSrc === "") {
          this.Dialoginfo('提示', '图片不能为空');
          return
        }
      } else {
        if (this.imageSrc === "") {
          this.Dialoginfo('提示', '图片不能为空');
          return
        }
      }
      AddNews(values.type, values.title, values.src, values.des, this.imageSrc, values.content).then(res => {
        if (res) {
          this.Dialoginfo('提示', '添加成功');
        } else {
          this.Dialoginfo('提示', '添加失败');
        }
      });
    },
    before_read(file) {
      // console.log(file);
      let fileTypes = file.name.split('.');
      let fileType = fileTypes[fileTypes.length - 1];
      if (fileType !== 'jpg' && fileType !== 'jpeg' && fileType !== 'png') {
        Dialog.alert({
          message: '请上传 jpg,jpeg,jpeg 格式文件',
        });
        return false;
      } else if (file.size > 5039264) {
        Dialog.alert({
          message: '文件过大,请保持在5M以内',
        });
        return false;
      }
      return true;
    },
    after_read(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      let data = new FormData();
      getToken().then(res => {
        data.append('token', res);     //七牛需要的token，叫后台给，是七牛账号密码等组成的hash
        // data.append('token', 'u6no7aFYuEeuEw6cIc3dB82YTeC_K3RnbWa78RA_:2c3JexJjS32mLROcJHD2p9Zs9s0=:eyJzY29wZSI6Imhoc3R1LXNwb3J0cyIsImRlYWRsaW5lIjoxNTk3NzQ3ODIzfQ==');     //七牛需要的token，叫后台给，是七牛账号密码等组成的hash
        // data.append('file', file);
        data.append("file", file.file);
        upLoadImageToQiNiu(data).then(data => {
          // console.log(data);
          this.imageSrc = 'http://cdn.sport.hhstu.club/' + data.data.key;
          file.status = 'done';
          file.message = '导入成功';
        }).catch(function (err) {
          file.status = 'failed';
          file.message = '导入失败';
        });

      }).catch(res => {
        file.status = 'failed';
        file.message = '导入失败';
      })


    },
    delete_file() {
      this.fileList = [];
      return true;
    },
  }
}
</script>

<style scoped>

</style>
